import React from 'react'
import { moreInfo } from './Modal';
// Import Swiper styles
import "swiper/css";
import { Pagination  } from "swiper";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";


export default function Instructor_card(props) {
  return (
            <div className="instructors-cards-parent my-4">
                <Swiper
                    slidesPerView={3}
                    spaceBetween={24}
                    pagination={{ clickable: true }}
                    modules={[Pagination]}
                    breakpoints={{
                        0: { slidesPerView: 1, spaceBetween: 16 },
                        560: { slidesPerView: 2, spaceBetween: 18 },
                        860: { slidesPerView: 3, spaceBetween: 24 },
                    }}
                    className="instructorsSwiper"
                >
                    {props.instructors.map((instructor, idx) => (
                        <SwiperSlide key={instructor?.id ?? instructor?.name ?? idx}>
                            <div className="instructorCard">
                                <div className="instructorCard__media">
                                    <img
                                        src={instructor.image}
                                        alt={instructor.name ? `${instructor.name}` : 'Instructor'}
                                        className="instructorCard__img"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="instructorCard__body">
                                    <h5 className="instructorCard__title">{instructor.name}</h5>
                                    <button
                                        type="button"
                                        onClick={() => moreInfo(instructor)}
                                        className="btn btn-dark w-100"
                                    >
                                        Contacts
                                    </button>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

    
  )
}
